import { Injectable } from '@angular/core';

export enum AppLanguages {
  LANGUAGE_FRENCH = 'fr',
  LANGUAGE_ENGLISH = 'en',
}

@Injectable()
export class AppService {
  appLanguage: AppLanguages = AppLanguages.LANGUAGE_FRENCH;

  constructor() {
    const localStorageLanguage: string | null =
      localStorage.getItem('language');

    if (localStorageLanguage) {
      if (
        Object.values(AppLanguages).includes(
          localStorageLanguage as AppLanguages
        )
      ) {
        this.appLanguage = localStorageLanguage as AppLanguages;
      }
    }
  }

  changeLanguage(newLanguage: AppLanguages): void {
    this.appLanguage = newLanguage;
    localStorage.setItem('language', newLanguage);
  }

  getAvailableLanguages(): AppLanguages[] {
    return [AppLanguages.LANGUAGE_ENGLISH, AppLanguages.LANGUAGE_FRENCH];
  }

  getAppLanguage(): AppLanguages {
    return this.appLanguage;
  }

  /**
   * Get a country flag as emoji from a country code
   */
  getFlagByCountryCode(code: string): string {
    code = code.toUpperCase();
    if (code == 'EN') return '🇬🇧';
    if (code == 'ES') return '🇪🇸';
    if (code == 'FR') return '🇫🇷';
    return '🏳';
  }
}
